export default function datesAreInSameMonth(date1, date2) {
	return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth();
}